import { useEffect, useState } from 'react';

import { Button } from '@gearbelt/ui/components';

import trucksAndWorkers from '@/assets/trucks-and-two-workers.svg';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import { useSignUpStore } from '@/stores/signup.store';
import { useWorkspaceSetupStore, WorkspaceSetupSteps } from '@/stores/workspace-setup.store';

export const WorkspaceSetupWelcomeModal = () => {
  const { workspaceSetupStep, setWorkspaceSetupStep, clearWorkspaceSetupStore } = useWorkspaceSetupStore();
  const { clearSignUpStore } = useSignUpStore();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(workspaceSetupStep === WorkspaceSetupSteps.WelcomeModal);
  }, [workspaceSetupStep]);

  function handleClose(isOpen: boolean) {
    setOpen(isOpen);
    if (!isOpen) {
      setWorkspaceSetupStep(WorkspaceSetupSteps.Complete);
      clearWorkspaceSetupStore();
      clearSignUpStore();
    }
  }

  return (
    <Dialog open={open} onOpenChange={(isOpen) => handleClose(isOpen)}>
      <DialogContent className="h-fit w-[500px] gap-0 p-8">
        <DialogHeader className="flex flex-col items-center justify-center space-y-0 pb-2">
          <DialogTitle className={cn('text-default-text flex w-full items-start justify-end gap-6 text-xl')}>
            <img src={trucksAndWorkers} alt="trucks and workers image" className="h-32 w-80 text-center" />
          </DialogTitle>
          <span className="mt-0 py-4 text-xl font-medium"> Welcome to Gearbelt</span>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center gap-4 text-center text-sm">
          <p>Eliminate manual asset management and clunky apps with Gearbelt to improve asset performance and ensure compliance.</p>
          <p>Enjoy your 30-day free trial!</p>

          <Button variant="success" className="mt-3 w-fit text-sm" type="button" onClick={() => handleClose(false)}>
            Get started
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
